// extracted by extract-css-chunks-webpack-plugin
module.exports = {"main_content":"main_content-3FgBbO3s","end":"end-2Z2YMOQb"};